<script setup lang="ts">
import ToggleSwitch from 'primevue/toggleswitch';
import { generateTranslationKey } from '~/utilities/data-transformers';
import type { IElement } from '~/interfaces/form/formBuilder';
const props = defineProps<{
  idx?: number;
  formTitle?: string;
  element?: IElement;
}>();
const { $t } = useNuxtApp();
const model = defineModel<boolean>();
const site = useSiteStore();
const label = computed(() =>
  $t(
    generateTranslationKey(
      `label.${props.element.label}-${site.getRegionCode}`,
    ),
    generateTranslationKey(`label.${props.element.label}`),
  ),
);
</script>
<template>
  <p
    v-if="idx === 1 && formTitle === 'otp options'"
    class="text-base-priority text-xs py-2 w-full"
  >
    {{ $t('select-preferred-communication-option') }}
  </p>
  <div
    class="flex text-base-priority items-center justify-start gap-2 form-builder-toggle"
    :class="{
      'absolute bottom-3 right-0': element.id === 'email',
    }"
  >
    <ToggleSwitch v-model="model" :input-id="element.id" :name="element.id" />
    <label class="truncate text-ellipsis" :for="element.id" :title="label">
      {{ label }}
    </label>
  </div>
</template>
